import React, { Component } from 'react';
import { Modal, Button, FormGroup, FormControl} from 'react-bootstrap';
import {DashboardAction, makeShowmodalFalse, showModalLogin, ReLogin} from './UserActions'
import {LogoutAction} from '../Login/LoginActions'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import iQumex from '../../Resources/images/iQumex-logo.jpg'
import logo from '../../Resources/images/logo.png'
class Dashboard extends Component {
  constructor(props){
    super(props)
    this.state={
       sideNavigationOpen: typeof props.size !== 'undefined' ? props.size : true,
       showReports:false,
       id:props.loginAction.userName ? props.loginAction.userName : ''
    }
  }
  
  componentDidMount(){    
   window.onload = function(event) {       
   this.props.logout(this.props.loginAction.userName, this.props.history) 
   }.bind(this)
   if(!_.isEmpty(this.props.loginAction.expirySeconds)){
      let timelapse = parseInt(this.props.loginAction.expirySeconds)
      timelapse = timelapse - 60000
      setTimeout(() => {
        this.calledTimeout()
       },  timelapse);
    }
  } 
  calledTimeout = () =>{
   this.props.showModalLoginModal()
  }
   toogleClickHAndler = () => {
    this.props.dashbaordac(!this.state.sideNavigationOpen)
    this.setState((prevState) =>{
      return {sideNavigationOpen: !prevState.sideNavigationOpen};
    })};
  createSideNavigation = (data) =>{
     return  _.map(data, (obj) =>{
      return(       
          <li onClick={this.toogleClickHAndler}><Link to={obj.path} className={(this.props.location.pathname === obj.path) ? 'active' :'' }>
          <span><i class={obj.icon}></i></span>
          {obj.moduleName.toUpperCase()}</Link></li>
        )
      })
  } 
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  handleSubmit = event => {
    event.preventDefault();   
  }
  login = () => {
    this.props.action(this.state.id, this.state.password)
    //this.props.makeShowmodalFalse()
  }
  showReportsHandle = () =>{
    this.setState((prevState) =>{
      return {showReports: !prevState.showReports};
    })
  }
  
  render(){
    const {reportOptions} = this.props
    let module = _.find(this.props.menuOptions, {'path':this.props.location.pathname})
    let reports = _.find(reportOptions, {'path':this.props.location.pathname})
    const{sideNavigationOpen, showReports} = this.state
    let newClassName= 'nav-sm';
    let topnav='top_navSmall';
    let show= 'HideElement'
    if(sideNavigationOpen){
        newClassName= 'nav-md';
        topnav = 'top_nav'
        show= 'showElement'
    } 
    return (
      <div>
      <div className={newClassName}>
        <div className="container-fluid body">
        <div class="main_container">
          <div class="col-md-3 left_col">
            <p className={show + ' User_Circle'}>
            <img src={iQumex} className='Project_iQumexLogo' alt={'logo1'} width='78%'/>
            <img src={logo} className='Project_Logo' alt={'logo'}/>
            </p> 
            <div class="scroll-view left_col">   
            <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
            <div class="menu_section">       
            <ul class="nav side-menu"> 
            <li onClick={this.showReportsHandle}><Link><span style={{color:'white', fontSize:'12px'}}>
            <i class="fas fa-cubes"></i>APPLICATION MODULE</span> {
               showReports === false ? <i className="fas fa-caret-up alignRight marginTop"/>
                 : <i className="fas fa-caret-down alignRight marginTop"/>}
               </Link></li>
              {showReports === false ? 
              this.createSideNavigation(this.props.menuOptions)
              : null}
             </ul>
             {(!_.isEmpty(reportOptions)) ?
             <div>
             <ul class="nav side-menu"> <li onClick={this.showReportsHandle}><Link><span style={{color:'white', fontSize:'12px'}}>
             <i class="fas fa-file-excel"></i>REPORTS MODULE </span>{
               showReports === true ? <i className="fas fa-caret-up alignRight marginTop"/>
                 : <i className="fas fa-caret-down alignRight marginTop"/>}
               </Link></li>
             </ul>
             {showReports === true ? 
              <ul class="nav side-menu"> 
                {_.map(reportOptions, (obj) =>{
                return( 
                    <li onClick={this.toogleClickHAndler}>                    
                    <Link to={obj.path} className={(this.props.location.pathname === obj.path) ? 'active' :'' }> 
                    {obj.reportName.toUpperCase()}</Link></li>
                  )
                })
                }
              </ul>
             : null }
             </div>
             : null}
             
           
           
        </div>
      </div>
      </div>
        </div>
      
      <div class={topnav}>
        <div class="nav_menu">
        <nav>
          <div class="nav toggle">
          <p id="menu_toggle">{
            sideNavigationOpen ? 
            <i class="fas fa-arrow-circle-left" onClick={this.toogleClickHAndler} />            
          :  <i class="fas fa-arrow-circle-right" onClick={this.toogleClickHAndler}/> }
          </p>               
          </div> 
          <div className='alignLeft moduleName'>
          <span><h6><b>{module ? module.moduleName.toUpperCase() : reports ? reports.reportName.toUpperCase() : null }          
          </b></h6></span>
            </div>
          <div className='alignRight'>
          <span className='Margin'><h6>{this.props.loginAction.firstName}        
          <i class="fas fa-power-off" onClick={()=>this.props.logout(this.props.loginAction.userName, this.props.history)}></i>       
          </h6></span>
            </div>
        </nav>
        </div>
      </div> 
        
    </div>
    </div>  
        
    </div>
        <div>         
        {this.props.showModalLogin === true ?
          <Modal className="relogin" show={this.props.showModalLogin}
          onHide={this.props.makeShowmodalFalse}
          dialogClassName="modal-120w"
          size='sm'
          backdrop='static'          
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered>     
          <Modal.Body>
          <div className='modalLogin'>
            <center>
          <img src={iQumex} className='Project_iQumexLogo' alt={'logo1'} width='100%'/></center>
          <div className='login_content'>  
          <p>Session Expired! Kindly relogin!!</p>       
         <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="id" >          
            <FormControl
              autoFocus
              type="id"
              value={this.state.id}
              onChange={this.handleChange}
              placeholder = {"User ID"}
            />
          </FormGroup>
          <FormGroup controlId="password">
           <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
              placeholder = {"Password"}
            />          
          </FormGroup>
          <br/>          
          <Button
            type="submit"
            className="alignLeft buttonwidth"
            onClick={this.login}
          >
            Login
          </Button>
          </form>
          </div>
          </div>
          </Modal.Body>
          </Modal>
         : null} 
        </div>
    </div>
    )
}
}
function mapStateToProps(state){
  return{
  size: state.UserReducer.large,
  loginAction: state.LoginReducer.loginAction,
  menuOptions: state.LoginReducer.menuOptions,
  showModalLogin: state.UserReducer.showModalLogin,
  reportOptions: state.LoginReducer.reportOptions,
  }
}
const mapDispatchToProps = (dispatch) => ({
  action: (a, b, c) => dispatch(ReLogin(a, b, c)),
  dashbaordac:  (a) =>dispatch(DashboardAction(a)), 
  logout:  (a, b) =>dispatch(LogoutAction(a, b)), 
  showModalLoginModal:  (a, b) =>dispatch(showModalLogin(a, b)), 
  makeShowmodalFalse:() => dispatch(makeShowmodalFalse())
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
